// Russian labels 1:1 with the client_drawer.jsx design vocabulary.
export const CLIENT_LINK_RELATION_LABELS_RU = {
    spouse: "Супруг(а)",
    partner: "Партнёр",
    relative: "Родственник",
    friend: "Друг",
    colleague: "Коллега",
};
//# sourceMappingURL=index.js.map